interface IItemPendancy {
    pend_Status: string,
    pend_DataEntrada: Date,
    pend_DataPrevisao: Date | null
}

const MAX_HOUR = 3;

const statusColor = (pendency: IItemPendancy): string => {
    const calcDate = new Date(pendency.pend_DataEntrada);
    const hour = calcDate.getHours();
    calcDate.setHours(hour + MAX_HOUR);    

    if (pendency.pend_Status === "FINALIZADO")
      return "success";

    if (!pendency.pend_DataPrevisao && new Date() > calcDate)
      return "error";
    
    if (pendency.pend_DataPrevisao && new Date() > new Date(pendency.pend_DataPrevisao))
      return "error";

    return "warning";
}

export { statusColor };